/**
 * Inicializa botón scroll to top usando markup del partial
 */
export const initScrollTopButton = ({ offset = 200 } = {}) => {
  /** @type {HTMLElement|null} */
  let button = document.querySelector('.js-scroll-top');

  if (!button) {
    button = document.createElement('a');

    button.className = `
      link link-variant-button btn-icon btn-icon-right 
      stretched-link icon-link link-black 
      scroll-top js-scroll-top
    `.trim();

    button.setAttribute('aria-label', 'Volver arriba');
    button.setAttribute('href', '#');

    button.innerHTML = `
      <svg class="bc bi bi-square-lg">
        <use xlink:href="#custom-arrow-right"></use>
      </svg>
    `;

    document.body.appendChild(button);
  }

  /**
   * Mostrar / ocultar
   */
  const toggleVisibility = () => {
    button.classList.toggle('is-visible', window.scrollY > offset);
  };

  /**
   * Scroll top
   */
  const handleClick = (e) => {
    e.preventDefault();

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  button.addEventListener('click', handleClick);
  window.addEventListener('scroll', toggleVisibility, { passive: true });

  toggleVisibility();
};